import type { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

interface SVGRProps {
  title?: string;
  titleId?: string;
  size?: keyof typeof unitMapping;
}

export const Team = ({
  size = 2,
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#clip0_2366_2947)">
      <path
        d="M9.43121 3.69434L16.0699 12.7998H10.9088L8.8902 10.1729L6.69684 11.1709L3.04938 10.6719V10.0996L5.88629 9.5127L7.32477 7.44238L5.72028 6.64062L7.68121 3.69434H9.43121ZM7.78375 2.08008L1.53668 11.2949L0.628479 12.0713L0.730042 11.2373L1.29156 10.4014L0.135315 10.4004L4.29938 3.74023H5.76715L7.20465 1.59961L7.78375 2.08008Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2366_2947">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
